export enum FrontendAction {
  // dossiers
  DownloadPdf = 'download-pdf',
  DownloadDismissedPdf = 'download-dismissed-pdf',
  // dossiers close
  DossiersClose = 'close-dossier',
  // dossiers assign
  DossiersAssign = 'assign-dossier',
  // findings
  FindingChangeDecision = 'finding-change-decision',
  FindingDecide = 'finding-decide',
  FindingExpand = 'finding-expand',
  FindingClickSource = 'finding-click-source',
  // reviews
  UnorderedReview = 'unordered-review',
  // list view search
  ListViewSearch = 'list-view-search',
  // utm_source
  UtmSource = 'utm-source',
}

export enum FeatureKeys {
  ReviewAssignments = 'review-assignments',
  Snooze = 'snooze',
  SnoozeExtendedExpiry = 'snooze-extended-expiry',
  Insights = 'insights',
  ReviewsListView = 'reviews-list-view',
  ReviewsListViewFull = 'reviews-list-view-full',
  ReviewsListViewHybrid = 'reviews-list-view-hybrid',
  Reinvestigations = 'reinvestigations',
  ReinvestigationsCanStart = 'can-start-reinvestigations',
  Screenshot = 'screenshot',
  WorkersComp = 'workers-comp',
  ReviewCounter = 'review-counter',
  DownloadDossiers = 'download-dossiers',
  IncludeFindingsCsvData = 'include-findings-csv-data',
  AllowUploadZip = 'allow-upload-zip',
  SkipUnorderedWarningPrompt = 'skip-unordered-warning-prompt',
  AdvancedInsights = 'advanced-insights',
  DisplayFindingsPriorityBanner = 'display-findings-priority-based-on-ai-banner',
  EmailNotify24hrFileReady = '24hr-ready-email-notify',
  EmailNotifyAllFileReady = 'all-ready-email-notify',
  AcceptConclusionReasons = 'accept-conclusion-reasons',
  SocialProfilesInClaimInfo = 'social-profiles-in-claim-info',
  LtdClaimsBuckets = 'ltd-claims-buckets',
  DisablePremiumWaiverBucket = 'disable-premium-waiver-bucket',
  DownloadUsersCSV = 'download-users-csv',
}

export type FeaturesResponse = Array<FeatureKeys>;

export enum DataDogAction {
  DossierNameCellButton = 'dossier-name-cell-button',
  DossierPageHeaderTitle = 'dossier-page-header-title',
  ItemRowCustom = 'item-row-custom',
  ItemRowText = 'item-row-text',
  ItemRowUrl = 'item-row-url',
  RowItem = 'row-item',
  ValidationLink = 'validation-link',
  ScreenshotDeletionButton = 'screenshot-deletion-button',
  FeedbackDossierNameCellButton = 'feedback-dossier-name-cell-button',
}
